exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".toolbarContainer__2GEQE{height:3em;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:stretch;-ms-flex-pack:stretch;justify-content:stretch;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-negative:0;flex-shrink:0}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/layout/toolbar/C:/dev/globalTopBar/src/components/layout/toolbar/C:/dev/globalTopBar/src/components/layout/toolbar/styles.scss"],"names":[],"mappings":"AAAA,yBACE,WACA,oBAAA,oBAAA,aACA,yBAAA,sBAAA,wBACA,yBAAA,sBAAA,mBACA,oBAAA,aAAc,CACf","file":"styles.scss","sourcesContent":[".toolbarContainer {\n  height: 3em;\n  display: flex;\n  justify-content: stretch;\n  align-items: center;\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"toolbarContainer": "toolbarContainer__2GEQE"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--4-2!../node_modules/postcss-loader/lib??postcss!../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./components/layout/toolbar/styles.scss
// module id = PU2a
// module chunks = 0